<template>
    <div>
        <PullContainer ref="pullContainerRef"  :pullDownLoading="true" :pullDownLabel="true" @pullDownLoadingSuccess="pullDownLoadingSuccess">
            <template #container>
                <div class="public_container">
                    <Head></Head>
                    <div class="mobile_container">
                        <div class="all_functions_wrap">
                           <div class="all_functions_list" v-for="item in navList">
                               <div class="all_functions_title" v-text="item.title"></div>
                               <div class="all_functions_bottom">
                                   <ul>
                                       <li v-for="child in item.children" @click="handleClickLink(child)">
                                            <div class="icon"></div>
                                            <p v-text="child.title"></p>
                                       </li>
                                   </ul>
                               </div>
                           </div>
                        </div>
                    </div>
                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                </div>
            </template>
        </PullContainer>
    </div>

</template>
<script>
import PullContainer from '@/components/mComponents/PullContainer.vue'
import Head from '@/components/mComponents/Head.vue'
import FooterTabbar from '@/components/mComponents/FooterTabbar.vue'
export default {
    name: 'mobileAllFunctions',
    data () {
        return {
            tabBarList:[
                {
                    icon:'icon-gongzuotai_weixuanzhong1',
                    activeIcon:'icon-gongzuotai_xuanzhong',
                    routerName:'mobileWorkBench',
                    title:'工作台'
                },
                {
                    icon:'icon-renwu_weixuanzhong',
                    activeIcon:'icon-renwu_xuanzhong',
                    routerName:'mobileTodo',
                    title:'待办'
                },
                {
                    icon:'icon-xiaoxi',
                    activeIcon:'icon-xiaoxi1',
                    routerName:'Message',
                    title:'消息'
                },
                {
                    icon:'icon-gengduogongneng_weixuanzhong',
                    activeIcon:'icon-gengduogongneng_xuanzhong',
                    routerName:'mobileAllFunctions',
                    title:'全部'
                },
            ],
            tabBarActive:3,
            navList: [
                {
                    title:'协同办公',
                    children:[
                        {title:'审批',name:'mobileApproval',path:'',icon:''},
                    ]
                },
                {
                    title:'客户管理',
                    children:[
                        {title:'客户管理',name:'MCustomerSeas',path:'',icon:''},
                        {title:'订单管理',name:'Order',path:'',icon:''},
                        {title:'商机管理',name:'Business',path:'',icon:''},
                    ]
                },
                {
                    title:'人事管理',
                    children:[
                        {title:'部门',name:'MPersonnelIndex',path:'',icon:''},
                    ]
                },
                {
                    title:'库存管理',
                    children:[
                        {title:'库存管理',name:'InventoryManagement',path:'',icon:''},
                        {title:'采购管理',name:'Purchase',path:'',icon:''},
                    ]
                },
                {
                    title:'项目管理',
                    children:[
                        {title:'项目管理',name:'ProjectManagement',path:'',icon:''},
                    ]
                },

                {
                    title:'财务管理',
                    children:[
                        {title:'财务管理',name:'FinanceManagement',path:'',icon:''},
                    ]
                },
                {
                    title:'考勤管理',
                    children:[
                        {title:'打卡',name:'mobileClockIn',path:'',icon:''},
                    ]
                },
                {
                    title:'工单管理',
                    children:[
                        {title:'工单管理',name:'WorkOrder',path:'',icon:''},
                    ]
                },
            ]
        }
    },
    mounted () {

    },
    methods: {
        pullDownLoadingSuccess(flag){
            if(flag){
                setTimeout(()=>{
                    this.$refs.pullContainerRef.pullDownLoadingEnd()
                },3000)
            }
        },
        // 跳转
        handleClickLink(item){
            let isPush = false
            this.$router.push({
                name:item.name,
                params: {
                    isPush:isPush,
                },
            })
        },
    },
    components: {
        PullContainer,
        Head,
        FooterTabbar
    }
}
</script>

<style lang="scss" scoped>
    .all_functions_wrap{
        width: 100%;
        padding: 10px 16px;
        box-sizing: border-box;
        .all_functions_list{
            padding-bottom: 12px;
            .all_functions_title{
                color: rgba(51, 51, 51, 1);
                font-size: 14px;
                line-height: 22px;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .all_functions_bottom ul{
                display: flex;
                flex-wrap: wrap;
                li{
                    width: 20%;
                    text-align: center;
                    margin-bottom: 12px;
                    div{
                        width: 32px;
                        height: 32px;
                        border-radius: 6px;
                        background: rgba(204, 204, 204, 1);
                        margin: 0 auto;
                    }
                    p{
                        line-height: 18px;
                        color: rgba(102, 102, 102, 1);
                        font-size: 12px;
                        margin-top: 4px;
                    }
                }
            }

        }
    }
</style>
